import { render, staticRenderFns } from "./ContactsSelect.vue?vue&type=template&id=44cfe3b2&scoped=true"
import script from "./ContactsSelect.vue?vue&type=script&lang=js"
export * from "./ContactsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cfe3b2",
  null
  
)

export default component.exports